import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MobileFormatPipeModule } from '@pipes/mobile-format/mobile-format.module';
import { LinkedContactSummaryComponent } from './linked-contact-summary.component';

@NgModule({
  declarations: [LinkedContactSummaryComponent],
  imports: [CommonModule, FormsModule, NgSelectModule, MobileFormatPipeModule],
  exports: [LinkedContactSummaryComponent],
})
export class LinkedContactSummaryModule {}
